import CollogeIcon from "../../assets/icons/collogeIcon.svg";
export const Education = () => {
  return (
    <section className="flex flex-col flex-1 gap-6">
      <article className="flex flex-col gap-5">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col  bg-[#FDFDFD] rounded-xl border border-gray-200 ">
            <div className="flex flex-col gap-0.5 w-full">
              <h2 className="flex-1 gap-4 px-5 pt-3 pb-2 text-sm font-semibold leading-5 text-gray-900">
                Education
              </h2>
              <div className="flex flex-col bg-white rounded-xl border border-gray-200 ">
                <div className="flex flex-col gap-5 p-5">
                  <div className="flex gap-3 bg-white">
                    <img
                      src={CollogeIcon}
                      alt="Harvard"
                      className="w-[37px] h-[49px]"
                    />
                    <div className="flex flex-col flex-1 gap-2">
                      <div className="flex flex-col gap-1">
                        <h3 className="text-lg tracking-wide leading-7 text-gray-900">
                          Bachelors in Computer Science
                        </h3>
                        <p className="text-base font-medium leading-6 text-gray-600">
                          Harvard | Sep 2022 - Present
                        </p>
                      </div>
                      <p className="text-base leading-6 text-gray-600">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};
